import { useEffect, useState } from "react";
import { Button, Modal, Form, Col, Row } from "react-bootstrap";
import { OrientationVisModalProps } from "../interfaces/PatternView";
import { getFontColor, getStrokeFromColor } from "../services/VisServices";

function OrientationVisModal(props: OrientationVisModalProps) {
  const [newBodyOrientation, setNewBodyOrientation] = useState<number>(0);
  const [newHeadOrientation, setNewHeadOrientation] = useState<number>(0);

  const [width, setWidth] = useState<number>(500);
  const [height, setHeight] = useState<number>(500);

  const dancerScalingFactor = 0.2;
  function getOrientationVisCircleRadius() {
    const smallerDimension = Math.min(width, height);
    return dancerScalingFactor * smallerDimension;
  }

  const fieldOfView = 180;
  function clampHeadOrientation(currentBodyOrientation: number): number[] {
    const maxLeftHeadOrientation =
      (currentBodyOrientation - fieldOfView / 2) % 360;
    const maxRightHeadOrientation =
      (currentBodyOrientation + fieldOfView / 2) % 360;

    if (maxLeftHeadOrientation > maxRightHeadOrientation) {
      if (currentBodyOrientation === 315) {
        return [-maxLeftHeadOrientation + 90, maxRightHeadOrientation];
      } else {
        return [-maxLeftHeadOrientation, maxRightHeadOrientation];
      }
    }

    return [maxLeftHeadOrientation, maxRightHeadOrientation];
  }

  useEffect(() => {
    const minOrientation = clampHeadOrientation(newBodyOrientation)[0];
    const maxOrientation = clampHeadOrientation(newBodyOrientation)[1];

    if (newHeadOrientation < minOrientation) {
      setNewHeadOrientation(minOrientation);
    }
    if (newHeadOrientation > maxOrientation) {
      setNewHeadOrientation(maxOrientation);
    }
  }, [newBodyOrientation]);


  function applyOrientations(e: any, id: number) {
    props.rotateDancerBody(props.selectedPattern, id, newBodyOrientation);
    props.rotateDancerHead(props.selectedPattern, id, newHeadOrientation);
    props.setShowModal(false);
    if (props.setShowModalForPatternView) {
      props.setShowModalForPatternView(false);
    }
  }

  function applyOrientationsForAllSingleDancers(e: any) {
    const candidates = getBrush();

    candidates.forEach(id =>  {
      const couple = props.pattern.positions[Math.floor((id - 1) / 2)];
      if (!couple.joint) {
        applyOrientations(e,id);
      }
    })
  }


  function applyOrientationsForAllSingleGentlemen(e: any) {
    const candiates = getBrush();
    candiates.forEach((id) => {
      const couple = props.pattern.positions[Math.floor((id - 1) / 2)];
      const isMale = ((id - 1) % 2 === 0);

      if (!couple.joint && isMale) {
        applyOrientations(e, id);
      }
    });
    
  }


  function applyOrientationsForAllSingleLadies(e: any) {
    const candiates = getBrush();
    candiates.forEach((id) => {
      const couple = props.pattern.positions[Math.floor((id - 1) / 2)];
      const isFemale = ((id - 1) % 2 === 1);
      
      if (!couple.joint && isFemale) {
        applyOrientations(e, id);
      }
    });
  }

  function applyOrientationsForAllCoupleDancers(e: any) {
    const candidates = getBrush();

    candidates.forEach(id =>  {
      const couple = props.pattern.positions[Math.floor((id - 1) / 2)];
      if (couple.joint) {
        applyOrientations(e,id);
      }
    })
  }


  function applyOrientationsForAllCoupleGentlemen(e: any) {
    const candiates = getBrush();
    candiates.forEach((id) => {
      const couple = props.pattern.positions[Math.floor((id - 1) / 2)];
      const isMale = ((id - 1) % 2 === 0);

      if (couple.joint && isMale) {
        applyOrientations(e, id);
      }
    });
    
  }


  function applyOrientationsForAllCoupleLadies(e: any) {
    const candiates = getBrush();
    candiates.forEach((id) => {
      const couple = props.pattern.positions[Math.floor((id - 1) / 2)];
      const isFemale = ((id - 1) % 2 === 1);
      
      if (couple.joint && isFemale) {
        applyOrientations(e, id);
      }
    });
  }

  function getBrush() {
    const candiates = [...props.brushSelectedDancers];
    if (candiates.length === 0) {
      for (let i=1; i<=2*props.numCouples; i++) {
        candiates.push(i);
      }
    } 
    return candiates;
  }

  function getAllRotationCandidateAmountCouples() {
    const candidates = getBrush();

    let count = 0;
    candidates.forEach(id => {
        const couple = props.pattern.positions[Math.floor((id - 1) / 2)];

        if (couple.joint) {
          count++;
        } 
      });
    return count;
    
  }
  

  function getGentlemenRotationCandidateAmountCouples() {
    const candidates = getBrush();
    let count = 0;
    candidates.forEach((id) => {
      const couple = props.pattern.positions[Math.floor((id - 1) / 2)];
      const isMale = ((id - 1) % 2 === 0);

      if (!couple.joint && isMale) {
        count++;
      }
    });
    return count;
    
  }

  function getLadiesRotationCandidateAmountCouples() {
    const candidates = getBrush();
    let count = 0;
    candidates.forEach((id) => {
      const couple = props.pattern.positions[Math.floor((id - 1) / 2)];
      const isFemale = ((id - 1) % 2 === 1);

      if (couple.joint && isFemale) {
        count++;
      }
    });
    return count;
  }



  function getAllRotationCandidateAmountSingles() {
    const candidates = getBrush();

    let count = 0;
    candidates.forEach(id => {
        const couple = props.pattern.positions[Math.floor((id - 1) / 2)];
        const isMale = ((id - 1) % 2 === 0);

        if (!couple.joint) {
          count++;
        } 
      });
    return count;
    
  }
  

  function getGentlemenRotationCandidateAmountSingles() {
    const candidates = getBrush();
    let count = 0;
    candidates.forEach((id) => {
      const couple = props.pattern.positions[Math.floor((id - 1) / 2)];
      const isMale = ((id - 1) % 2 === 0);

      if (!couple.joint && isMale) {
        count++;
      }
    });
    return count;
    
  }

  function getLadiesRotationCandidateAmountSingles() {
    const candidates = getBrush();
    let count = 0;
    candidates.forEach((id) => {
      const couple = props.pattern.positions[Math.floor((id - 1) / 2)];
      const isFemale = ((id - 1) % 2 === 1);

      if (!couple.joint && isFemale) {
        count++;
      }
    });
    return count;
  }






  useEffect(() => {
    if (props.showModal) {
      setNewBodyOrientation(props.pos!.bodyOrientation);
      setNewHeadOrientation(props.pos!.headOrientation);
    }
  }, [props.showModal]);

  return (
    <Modal
      show={props.showModal}
      onHide={() => {
        props.setShowModal(false);
        if (props.setShowModalForPatternView) {
          props.setShowModalForPatternView(false);
        }
      }}
      onClick={(e: any) => {
        e.stopPropagation();
      }}
      onMouseDown={(e: any) => {
        e.stopPropagation();
      }}
    >
      <Modal.Header closeButton>
        <Modal.Title>Set Dancer orientation</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div
          id="modal-wrapper"
          style={{ width: width + "px", height: height + "px" }}
        >
          <svg id="orientation-vis" width="100%" height="100%">
            <g transform={`translate(${width / 2}, ${height / 2})`}>
              <line
                x1={0}
                y1={0}
                x2={
                  1.5 *
                  getOrientationVisCircleRadius() *
                  Math.sin(newHeadOrientation * (Math.PI / 180))
                }
                y2={
                  -1.5 *
                  getOrientationVisCircleRadius() *
                  Math.cos(newHeadOrientation * (Math.PI / 180))
                }
                stroke={"gray"}
                strokeWidth={5}
              />

              <path
                fill={props.frontsideColor}
                stroke={getStrokeFromColor(props.frontsideColor,0.2)}
                d={
                  "M " +
                  -getOrientationVisCircleRadius() +
                  " 0 A " +
                  getOrientationVisCircleRadius() +
                  " " +
                  getOrientationVisCircleRadius() +
                  " 0 0 1 " +
                  getOrientationVisCircleRadius() +
                  " 0"
                }
                transform={`rotate(${newBodyOrientation})`}
              />
              <path
                fill={props.backsideColor}
                stroke={getStrokeFromColor(props.frontsideColor,0.2)}
                d={
                  "M " +
                  -getOrientationVisCircleRadius() +
                  " 0 A " +
                  getOrientationVisCircleRadius() +
                  " " +
                  getOrientationVisCircleRadius() +
                  " 0 0 0 " +
                  getOrientationVisCircleRadius() +
                  " 0"
                }
                transform={`rotate(${newBodyOrientation})`}
              />

              <text fill={getFontColor(props.frontsideColor)} fontSize={"5em"} x={"-0.32em"} y={"0.3em"}>
                {Math.ceil(props.dancerId / 2)}
              </text>
            </g>
          </svg>
        </div>
        <Form>
          {props.editingModeActive && (
            <Form.Group
              className="mb-3"
              as={Row}
              //controlId="exampleForm.ControlTextarea1"
            >
              <Form.Label>Body orientation</Form.Label>
              <Col xs="10">
                <Form.Range
                  value={newBodyOrientation}
                  onChange={(e) => setNewBodyOrientation(+e.target.value)}
                  min={0}
                  max={315}
                  step={45}
                />
              </Col>
              <Col xs="2">
                <Form.Label>{newBodyOrientation + "°"}</Form.Label>
              </Col>
            </Form.Group>
          )}

          {props.editingModeActive && (
            <Form.Group
              className="mb-3"
              as={Row}
              //controlId="exampleForm.ControlTextarea1"
            >
              <Form.Label>Head orientation</Form.Label>
              <Col xs="10">
                <Form.Range
                  value={newHeadOrientation}
                  onChange={(e) => setNewHeadOrientation(+e.target.value)}
                  min={clampHeadOrientation(newBodyOrientation)[0]}
                  max={clampHeadOrientation(newBodyOrientation)[1]}
                  step={45}
                />
              </Col>
              <Col xs="2">
                <Form.Label>{newHeadOrientation + "°"}</Form.Label>
              </Col>
            </Form.Group>
          )}
        </Form>
      </Modal.Body>
      <Modal.Footer>
        {props.editingModeActive &&
          props.dancerId % 2 === 1 &&
          !props.joint && (
            <Button
              variant="secondary"
              onClick={applyOrientationsForAllSingleGentlemen}
            >
              {`Apply for single men (${getGentlemenRotationCandidateAmountSingles()})`}
            </Button>
          )}
        {props.editingModeActive &&
          props.dancerId % 2 === 0 &&
          !props.joint && (
            <Button variant="secondary" onClick={applyOrientationsForAllSingleLadies}>
              {`Apply for single ladies (${getLadiesRotationCandidateAmountSingles()})`}
            </Button>
          )}
        {!props.joint && props.editingModeActive && (
          <Button variant="secondary" onClick={applyOrientationsForAllSingleDancers}>
            {`Apply for all singles (${getAllRotationCandidateAmountSingles()})`}
          </Button>
        )}



        {props.editingModeActive &&
          props.dancerId % 2 === 1 && props.showGentlemanInCouple && props.joint &&
          (
            <Button
              variant="secondary"
              onClick={applyOrientationsForAllCoupleGentlemen}
            >
              {`Apply for men in couple (${getGentlemenRotationCandidateAmountCouples()})`}
            </Button>
          )}
        {props.editingModeActive &&
          props.dancerId % 2 === 0 && !props.showGentlemanInCouple && props.joint &&
          !props.joint && (
            <Button variant="secondary" onClick={applyOrientationsForAllCoupleLadies}>
              {`Apply for ladies in couple (${getLadiesRotationCandidateAmountCouples()})`}
            </Button>
          )}
        {props.editingModeActive && props.joint && (
          <Button variant="secondary" onClick={applyOrientationsForAllCoupleDancers}>
            {`Apply for all in couples (${getAllRotationCandidateAmountCouples()})`}
          </Button>
        )}


        {props.editingModeActive && (
          <Button
            variant="primary"
            onClick={(e) => applyOrientations(e, props.dancerId)}
          >
            Apply
          </Button>
        )}

        {!props.editingModeActive && (
          <Button
            variant="secondary"
            onClick={() => {
              props.setShowModal(false);
              if (props.setShowModalForPatternView) {
                props.setShowModalForPatternView(false);
              }
            }}
          >
            Close
          </Button>
        )}
      </Modal.Footer>
    </Modal>
  );
}

export default OrientationVisModal;
